import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import Meta from 'vue-meta';
import VueLazyload from 'vue-lazyload';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/fonts.css';
import './styles/global.css';
import router from './router';
import i18n from './i18n';
import { initVisitTracker } from './services/requrest';
// 引入CDN混入
import cdnMixin from './mixins/cdnMixin';

Vue.config.productionTip = false;

// 全局注册CDN混入
Vue.mixin(cdnMixin);

Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(Meta);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  lazyComponent: true,
});
Vue.use(ElementUI);

// 首次访问停留时间与路由上报初始化（仅记录一次）
initVisitTracker(router);

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
